/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

const u = undefined;

export default [
  [
    ['mi', 'n', 'in the morning', 'in the afternoon', 'in the evening', 'at night'],
    ['midnight', 'noon', 'in the morning', 'in the afternoon', 'in the evening', 'at night'], u
  ],
  [['midnight', 'noon', 'morning', 'afternoon', 'evening', 'night'], u, u],
  ['00:00', '12:00', ['06:00', '12:00'], ['12:00', '18:00'], ['18:00', '21:00'], ['21:00', '06:00']]
];
